// My events (☆) and Profile (👤), beside the search box (web/index.html #my-events-btn, #profile-btn). Tapping one
// again while its sheet is open closes it. Logged out (public mode) they open to the sign-in note (ProfileSheet).
import { T } from "../../shared/config";
import { Icon } from "../../shared/icons";
import { toggleSheet, useSheet } from "../../state/view";
import styles from "./profile.module.css";

export function ProfileButtons() {
  const open = useSheet()?.kind;
  return (
    <>
      <button type="button" id="my-events-btn" className={styles["icon-btn"]} aria-label={T("myEvents")} title={T("myEvents")} aria-pressed={open === "myevents"}
        onClick={() => toggleSheet("myevents")}><Icon name="star" /></button>
      <button type="button" id="profile-btn" className={styles["icon-btn"]} aria-label={T("profile")} title={T("profile")} aria-pressed={open === "profile"}
        onClick={() => toggleSheet("profile")}><Icon name="user" /></button>
    </>
  );
}
